import { useState, useEffect, useRef } from 'react';
import { random } from 'lodash';

const DEFAULT_MESSAGES = [
  'Cooking 🧑‍🍳 up engaging prompts for you',
  'Simulating 💬 human responses to these questions',
  'Sequencing 🎞️ interactive StreamAlive interactions.',
  'Serving up something 🍱 delicious soon',
  'Crafting 🎨 your StreamAlive masterpiece...',
  'Whispering 🤫 prompts to our AI muse...',
  'Brewing 🧪 a potion of engaging responses...',
  'Loading... ⏳ AI magic in progress...',
  'Setting the stage 🎭 for StreamAlive interactions...',
  'Warming up 🎙️ the mic for your AI co-star...',
  'Rehearsing 🎤 your AI-generated dialogue...',
  'Summoning 🪄 the spirit of conversation...',
  'Your StreamAlive adventure awaits... ✨',
  'Polishing 💎 your AI-generated gems...',
  'Curating 📖 the perfect AI response…',
  'Fine-tuning 🎻 your interactive symphony...'
];

const useLoadingMessages = (isLoading: boolean, interval: number = 800, customMessages?: string[]) => {
  const messages = customMessages?.length ? customMessages : DEFAULT_MESSAGES;
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (!isLoading && intervalRef.current) {
      clearInterval(intervalRef.current);
      return;
    }

    if (isLoading) {
      intervalRef.current = setInterval(() => {
        setCurrentMessageIndex(random(0, messages.length - 1));
      }, interval);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isLoading, interval, messages.length]);

  return messages[currentMessageIndex];
};

export default useLoadingMessages;
